const equipamentosEngenhariaClinica = [
  "AMALGAMADOR",
  "AUTOCLAVE",
  "BALANÇA ADULTO",
  "BALANÇA PEDIÁTRICA",
  "BALANÇA PORTÁTIL",
  "CADEIRA DE RODAS",
  "CAMA HOSPITALAR",
  "CÂMARA PARA VACINAS",
  "CANETA ALTA ROTAÇÃO",
  "COMPRESSOR",
  "CONSULTÓRIO ODONTOLÓGICO",
  "CONTRA ÂNGULO",
  "DERMATOSCÓPIO",
  "DESTILADORA",
  "DETECTOR FETAL",
  "ELETROCARDIÓGRAFO",
  "ESFIGMOMANÔMETRO",
  "ESFIGMOMANÔMETRO DIGITAL",
  "ESTETOSCÓPIO",
  "ESTETOSCÓPIO DIGITAL",
  "FOCO CLÍNICO",
  "FOTOPOLIMERIZADOR",
  "GLICOSÍMETRO / HGT / ON CALL PLUS",
  "INCUBADORA",
  "LAVADORA ULTRASSÔNICA",
  "MESA GINECOLÓGICA",
  "MESA GINECOLÓGICA MECÂNICA",
  "MICROMOTOR",
  "MOCHO",
  "NEBULIZADOR",
  "NEGATOSCÓPIO",
  "OFTALMOSCÓPIO",
  "OTOSCÓPIO",
  "OXÍMETRO",
  "PEÇA RETA",
  "RÉGUA ANTROPOMÉTRICA",
  "SELADORA",
  "SERINGA TRÍPLICE",
  "TERMÔMETRO AXILAR",
  "TERMÔMETRO CAIXA TÉRMICA",
  "TERMÔMETRO DE TESTA",
  "TERMÔMETRO DIGITAL",
  "TERMO-HIGRÔMETRO GELADEIRA",
  "ULTRASSOM ODONTOLÓGICO",
  "OUTROS",
];

export default equipamentosEngenhariaClinica;
